/**
 * Password rules shared by every form that sets a password.
 *
 * Must stay >= the Supabase Auth `password_min_length` setting on the project.
 * If the client allows a shorter password than the server does, the form accepts
 * it and the request then fails server-side with a raw API error, which reads as
 * a bug to the user. Change both together.
 */
export const PASSWORD_MIN_LENGTH = 10;
